import { useTranslation } from 'react-i18next'

import useRedux from './useRedux'

const useTranslations = () => {
  const { t, i18n } = useTranslation()
  const { selector } = useRedux()
  const displayName = selector(
    state => state?.user?.profile_details?.displayName,
  )
  const defaultVars = {
    displayName: displayName || 'MSTI',
    userNumber: '',
  }

  const translateWithVars = (key, variables = {}) => {
    return t(key, { ...defaultVars, ...variables })
  }

  return { t: translateWithVars, i18n }
}
export default useTranslations
